import schema from './schemaVersions/v6.js';
	const finalSchema = { wip: false, ...schema };
	export default finalSchema;